<template>
  <div>
    <!-- <TopNavbar /> -->
    <!-- {{Lang.get('messages.Forms.add_new_code')}} -->
    <!-- @lang('messages.welcome') -->

    <!-- <section
            class="md:flex bg-cover bg-no-repeat bg-center bg-cover bg-grey h-screen-2/5 mb-48"
        >
            
        </section> --> 
    

    <HomeSlider></HomeSlider>

    <SearchPackage></SearchPackage>
  </div>
</template>

<script>
import AlbumsMix from "./mixins/albums/GetAlbumsByEmail";
import SearchPackage from "./photo/searchPackageComponent";
import HomeSlider from "./sliders/HomeSlider.vue";


export default {
    props: [],
    mixins: [AlbumsMix],
    components: {
        HomeSlider,
        SearchPackage
    },
    computed: {},
    async created() {},
    async mounted() {
      const bootOptionsRequest = this.$store
        .dispatch("getOptions")
        .catch(() => []);

      await Promise.race([
        bootOptionsRequest,
        new Promise((resolve) => setTimeout(resolve, 3000)),
      ]);

      if (this.$store.getters.authStateLogged && this.$store.getters.hasAlbumsReady) {
        this.$router.push({ name: "albumes" });
        return;
      }

      if (this.$store.getters.authStateGuest && this.$store.getters.hasAlbumsReady) {
        this.$store.dispatch("setLogout");
        return;
      }
    }
};
</script>

<style></style>
